import React from 'react';
import {createRoot} from 'react-dom/client';
import 'core-js/actual';
import 'regenerator-runtime/runtime';
import 'scrollingelement';
import 'chartist-plugin-legend';
import 'chartist-plugin-tooltips';

import DOMUtils from '@spothero/utils/dom';
import StorageUtils from '@spothero/utils/storage';

import Config from 'hooks/config';
import CMSUtils from 'utils/cms';

import Root from './common/root/Root';

if (Config.isMobileDevice) {
    DOMUtils.addClass('html', 'mobile');
}

Config.set({
    debugSegmentInConsole:
        StorageUtils.get('sh-debug-segment', 'cookie') === true,
    debugWootricInConsole:
        StorageUtils.get('sh-debug-wootric', 'cookie') === true,
});

CMSUtils.init();
const container = document.getElementById('root');
const root = createRoot(container);

root.render(<Root />);
